import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';

var Action = function Action(_ref) {
  var Icon = _ref.icon,
      label = _ref.label,
      _onClick = _ref.onClick,
      onChange = _ref.onChange,
      props = _objectWithoutProperties(_ref, ["icon", "label", "onClick", "onChange"]);

  return React.createElement("div", Object.assign({}, props, {
    className: "flexbox flexbox-grow flexbox-align-center padding-medium shade-05 pointer font-weight-medium transition background-shade-50-on-hover",
    onClick: function onClick() {
      return onChange(_onClick);
    }
  }), React.createElement(Icon, {
    style: {
      width: 16,
      height: 16
    },
    className: "shade-30"
  }), React.createElement("span", {
    style: {
      marginLeft: 12,
      whiteSpace: 'nowrap'
    }
  }, label));
};

export default Action;